import { Button } from '@appkit4/react-components/button';
import './HomeCard.scss';

export type HomeCardProps = {
    imageSrc: string;
    imageAlt: string;
    heading: string;
    subheading: string;
    buttonKind: 'primary' | 'secondary' | 'tertiary' | 'text';
    buttonText: string;
    onButtonClick: () => void;
    backgroundColor?: string;
    buttonIcon?: string;
};

const HomeCard = ({
    imageSrc,
    imageAlt,
    heading,
    subheading,
    buttonKind,
    buttonIcon,
    buttonText,
    backgroundColor,
    onButtonClick,
}: HomeCardProps) => {
    return (
        <div>
            <div
                className="ms-2 me-2 mt-4 mb-4 new-panel"
                style={{ overflow: 'hidden', backgroundColor: 'white' }}
            >
                <div
                    style={{
                        backgroundColor: `${
                            backgroundColor
                                ? backgroundColor
                                : 'var(--color-background-primary)'
                        }`,
                    }}
                    className="p-4"
                >
                    <img
                        src={imageSrc}
                        alt={imageAlt}
                        style={{ width: '50%', filter: 'invert(1)' }}
                    />
                </div>
                <div className="d-flex flex-column p-4 home-card-content">
                    <div>
                        <h4 className="">{heading}</h4>
                        <div className="">{subheading}</div>
                    </div>
                    <div>
                        <Button
                            type="button"
                            kind={buttonKind}
                            icon={buttonIcon ? buttonIcon : ''}
                            onClick={onButtonClick}
                        >
                            {buttonText}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeCard;
